<template>
  <v-app>
    <v-main>
      <Header v-if="$route.path == '/'" :title="$t('name')"></Header>
      <notifications
          width="40%"
          animation-name="v-fade"
          group="failmessages"
          position="bottom right"
      >
        <template slot="body" slot-scope="props">
          <v-alert class="  px-0 py-0 mx-3 FailMessages">
            <v-layout   style="width:100% !important;justify-content: space-between;height:100%;align-items:center">

              <span class="" style="margin: auto 18px"> {{ $t(props.item.text) }}</span>
              <v-btn
                  text
                  small
                  @click="props.close"
                  class="customizedBtn cloeicon px-2"
                  style="margin: 14px"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-layout>
          </v-alert>
        </template>
      </notifications>
      <notifications
          width="40%"
          group="successmesages"
          position="bottom right"
      >
        <template slot="body" slot-scope="props">
          <v-alert class=" mx-3   px-0 py-0 SuccessMesages">
            <v-layout   style="width:100% !important;justify-content: space-between;height:100%;align-items:center">
              <span style="margin: auto 18px"> {{ $t(props.item.text) }}</span>
              <v-btn
                  text
                  small
                  @click="props.close"
                  class="customizedBtn cloeicon px-2"
                  style="margin:12px"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-layout>
          </v-alert>
        </template>
      </notifications>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { AbilityBuilder, Ability } from '@casl/ability';
import Header from "@/components/Header.vue";
import { mapActions } from "vuex";


export default {
  name: "App",
  components: {Header},

  watch: {
    '$vuetify.theme.dark': {
      immediate: true,
      handler(val) {
        if (typeof document !== 'undefined') {
          if (val) {
            document.documentElement.classList.add('theme--dark');
            document.documentElement.style.colorScheme = 'dark';
          } else {
            document.documentElement.classList.remove('theme--dark');
            document.documentElement.style.colorScheme = 'light';
          }
        }
      }
    }
  },

  created() {
    if (typeof window !== 'undefined' && window.localStorage) {
      const savedDark = localStorage.getItem('theme_dark');
      if (savedDark !== null) {
        this.$vuetify.theme.dark = savedDark === 'true';
      }
    }
  
    // this.$ability = this.$root.$ability;
  },

  data() {
    return {
      permissionRefreshInterval: null,
    };
  },
  methods: {
    ...mapActions(["refreshPermissions"]),
  },
  mounted() {
    // Refresh permissions every 5 minutes (300,000 ms)
    this.permissionRefreshInterval = setInterval(() => {
      if (this.$store.getters.isAuthenticated) {
        this.refreshPermissions();
      }
    }, 300000);

  },
  beforeDestroy() {
    if (this.permissionRefreshInterval) {
      clearInterval(this.permissionRefreshInterval);
    }
  },
};
</script>

<style>
.v-application--wrap {
  min-height: initial;
}

header.px-5.py-5.v-sheet.theme--dark.elevation-0.v-toolbar.v-app-bar.v-app-bar--fixed {
  padding: 0 !important;
  display: flex;
}

.v-progress-circular.loading-indicator.v-progress-circular--visible.v-progress-circular--indeterminate {
    height: 110vh !important;
    width: 100% !important;
    -webkit-backdrop-filter: blur(2.5px);
    backdrop-filter: blur(2.5px);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
}

.v-progress-circular > svg {
    width: 70px;
    height: 70px;
    color: #156967;
}

.txt-field .v-input__slot {
    background-color: white !important;
    /* border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important; */
}

.login-icon::before{
    border: 2px solid dimgray !important;
    border-radius: 100% !important;
    padding: 7px !important;
}

/* Soft / Smooth Scrolling & Momentum */
html {
  scroll-behavior: smooth;
}

html,
body,
.v-application,
.v-data-table__wrapper,
.stat-list-container {
  -webkit-overflow-scrolling: touch;
}

/* Custom Sleek Scrollbars (Fix Raw Browser Scrollbars) */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background: transparent !important;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
::-webkit-scrollbar-track,
html::-webkit-scrollbar-track-piece,
body::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-track-piece,
html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner,
::-webkit-scrollbar-corner {
  background: transparent !important;
}

html::-webkit-scrollbar-button,
body::-webkit-scrollbar-button,
::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb {
  background: #94A3B8;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover,
::-webkit-scrollbar-thumb:hover {
  background: #64748B;
}

/* Dark Mode Scrollbars */
html.theme--dark,
html.theme--dark body,
.theme--dark {
  color-scheme: dark !important;
}

html.theme--dark::-webkit-scrollbar,
html.theme--dark body::-webkit-scrollbar,
html.theme--dark ::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background: transparent !important;
}

html.theme--dark::-webkit-scrollbar-track,
html.theme--dark body::-webkit-scrollbar-track,
html.theme--dark ::-webkit-scrollbar-track,
html.theme--dark::-webkit-scrollbar-track-piece,
html.theme--dark body::-webkit-scrollbar-track-piece,
html.theme--dark ::-webkit-scrollbar-track-piece,
html.theme--dark::-webkit-scrollbar-corner,
html.theme--dark body::-webkit-scrollbar-corner,
html.theme--dark ::-webkit-scrollbar-corner {
  background: transparent !important;
}

html.theme--dark::-webkit-scrollbar-button,
html.theme--dark body::-webkit-scrollbar-button,
html.theme--dark ::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html.theme--dark::-webkit-scrollbar-thumb,
html.theme--dark body::-webkit-scrollbar-thumb,
html.theme--dark ::-webkit-scrollbar-thumb {
  background: #475569 !important;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

html.theme--dark::-webkit-scrollbar-thumb:hover,
html.theme--dark body::-webkit-scrollbar-thumb:hover,
html.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: #64748B !important;
}
</style>
